import { render, staticRenderFns } from "./NoviStepper.vue?vue&type=template&id=4aff3ae6&"
import script from "./NoviStepperVue.ts?vue&type=script&lang=ts&"
export * from "./NoviStepperVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports